import React from "react";
import styled from "styled-components";
import colors from "../../styles/colors";

const AppContainer = styled.div`

  max-width: 834px;
  height: 100%;
  margin: 0 auto;
  background-color: ${colors.bright};
  color: ${colors.dark};
`;
const CreateAppContainer = styled.div`

  max-width: 834px;
  height: auto;
  margin: 0 auto;
  background-color: ${colors.bright};
  color: ${colors.dark};
`;
const Header = styled.div`
 
  display: block;
  position: fixed;
  max-width: 834px;
  width: 100%;
  height: 5rem;
  background-color: ${colors.first};
  color: ${colors.bright};
  padding-top: 1rem;
`;

const Heading = styled.div`

  font-weight: 600;
  font-size: 1.5rem;
  line-height: 2;
  padding-left: 1rem;
 
`;

const Body = styled.div`
  flex: 1;
  height: 100%;
  width: 100%;
  color: ${colors.dark};
  padding-top: 7rem;
`;

const SortableListBody = styled.div`
  flex: 1;
  height: 100%;
  width: 100%;
  color: ${colors.dark};
  padding-top: 9rem;
`;

const MainAction = styled.div`
  display: flex;
  position: fixed;
  bottom: 2rem;
  width: 100%;
  max-width: 834px;
  align-items: center;
  justify-content: space-between;
`;

const ImageUploadClinicSection = styled.div`
  display: flex;
  bottom: 2rem;
  width: 100%;
  max-width: 834px;
  align-items: center;
  justify-content: space-between;
`;

const LogoutAction=styled.div`
float:right
`;

export { AppContainer, Header, Heading, Body, MainAction, SortableListBody,LogoutAction,CreateAppContainer,ImageUploadClinicSection };



// WEBPACK FOOTER //
// ./src/Components/AppChrome/index.js